import { public_urls, learningResourcesLinks } from '../config';
import { forecastNavigationLinks, forecastDropdownLinks } from './navigation';
import role from './role';

const prefix = 'IBM';
const appName = 'Security Assistant & Solution Center';
const learningResourcesTitle = 'Learning Resources';

export const HOME = {
  appName: {
    prefix,
    name: appName,
    homePage: {
      isExternal: false,
      link: public_urls.home,
    },
  },
  navigation: {
    dropdownLinks: forecastDropdownLinks,
  },
  learningResources: [
    {
      link: learningResourcesLinks.presentations,
      title: learningResourcesTitle,
      isExternal: true,
      roles: [role.SELLER],
      targetBlank: true,
    },
    {
      link: learningResourcesLinks.presentationsBP,
      title: learningResourcesTitle,
      isExternal: true,
      roles: [role.BP],
      targetBlank: true,
    },
  ],
};

export const FORECAST = {
  appName: {
    prefix,
    name: appName,
    homePage: {
      isExternal: false,
      link: public_urls.home,
    },
  },
  navigation: {
    navigationLinks: forecastNavigationLinks,
    dropdownLinks: forecastDropdownLinks,
  },
  learningResources: [
    {
      link: learningResourcesLinks.presentationsForecast,
      title: learningResourcesTitle,
      isExternal: true,
      targetBlank: true,
    },
  ],
};

export const SASC = {
  appName: {
    prefix,
    name: appName,
    homePage: {
      isExternal: false,
      link: public_urls.home,
    },
  },
  navigation: {
    dropdownLinks: forecastDropdownLinks,
  },
  learningResources: [
    {
      link: learningResourcesLinks.presentationsForecast,
      title: learningResourcesTitle,
      isExternal: true,
      targetBlank: true,
    },
  ],
};

export const REPORTS = {
  appName: {
    prefix,
    name: appName,
    homePage: {
      isExternal: false,
      link: public_urls.home,
    },
  },
  navigation: {
    dropdownLinks: forecastDropdownLinks,
  },
  learningResources: [
    {
      link: learningResourcesLinks.presentationsForecast,
      title: learningResourcesTitle,
      isExternal: true,
      targetBlank: true,
    },
  ],
};
